import { MeshStandardMaterial, DoubleSide, FrontSide } from 'three';

// gum color
export const gumMaterial = new MeshStandardMaterial({ color: 0xd07aa9, side: DoubleSide, roughness: 0.1 });
gumMaterial.shadowSide = FrontSide; // reduce self-shadowing on double-sided gum

export const toothMaterial = new MeshStandardMaterial({ color: 0xffffff, side: DoubleSide, roughness: 0.1 });
toothMaterial.shadowSide = FrontSide;

/** Per-tooth material instance (each tooth mesh gets its own clone). */
export function createToothMaterial(): MeshStandardMaterial {
  const material = toothMaterial.clone();
  material.shadowSide = FrontSide;
  return material;
}
